export default "__VITE_ASSET__d2e48f6e__"